module.exports = __webpack_public_path__ + "img/Ryo.abfe54fb.png";